import { Container, Grid } from '@mui/material'
import { FooterNavigation } from 'components/Navigation'
import React from 'react'
import { StyledFooter } from './styled'
import { StyledDefaultContainer } from 'components/AppContainer/styled'

export const Footer: React.FC = () => {
  return (
    <StyledFooter>
      <StyledDefaultContainer>
        <Grid
          container
          sx={{
            flexDirection: {
              xs: 'column',
              md: 'row'
            },
            alignItems: {
              xs: 'center'
            }
          }}
        >
          <Grid
            item
            xs={12}
            md={6}
            marginBottom={{ xs: 2, md: 0 }}
            display="flex"
            sx={{
              justifyContent: {
                xs: 'center',
                md: 'flex-start'
              }
            }}
          >
            <FooterNavigation />
          </Grid>
          <Grid item xs={12} md={6} display="flex" justifyContent="flex-end">
            <p>
              © 2024 כל הזכויות שמורות ל DRIVE AI | האתר לא קשור למשרד התחבורה
            </p>
          </Grid>
        </Grid>
      </StyledDefaultContainer>
    </StyledFooter>
  )
}
